import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/modules/shared/ui/components/tabs";
import { useWallet } from "../../hooks/use-wallet";
import { WalletBalanceCard } from "../components/WalletBalanceCard";
import { TopUpDialog } from "../components/TopUpDialog";
import { TransactionHistory } from "../components/TransactionHistory";
import { AiUsageDashboard } from "../components/AiUsageDashboard";

export function WalletPage() {
  const [topUpOpen, setTopUpOpen] = useState(false);
  const { data: wallet, isLoading } = useWallet();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Wallet</h1>
      </div>

      {wallet && (
        <WalletBalanceCard wallet={wallet} onTopUp={() => setTopUpOpen(true)} />
      )}

      <Tabs defaultValue="transactions">
        <TabsList>
          <TabsTrigger value="transactions">Transactions</TabsTrigger>
          <TabsTrigger value="ai-usage">AI Usage</TabsTrigger>
        </TabsList>

        <TabsContent value="transactions" className="mt-4">
          <TransactionHistory />
        </TabsContent>

        <TabsContent value="ai-usage" className="mt-4">
          <AiUsageDashboard />
        </TabsContent>
      </Tabs>

      <TopUpDialog open={topUpOpen} onOpenChange={setTopUpOpen} />
    </div>
  );
}
